<script context="module" lang="ts">export { specification } from "./spec";
</script>

<script lang="ts">import { BaseAtom } from "components/cards/atoms";
import { DateTime } from "luxon";
import { onDestroy } from "svelte";
import { ButtonParticle, ImageParticle, TextParticle, } from "components/cards/particles/YinzCam";
export let container;
export let txtAwayTeam;
export let imageAwayTeam;
export let matchDateTime;
export let matchStatus;
export let btnActions;
export let btnSponsors;
export let showCompLogo;
export let btnCupName;
export let txtMatchMonth;
export let txtMatchDay;
export let txtVersus;
export let txtResult;
export let txtLive;
export let txtLiveScore;
export let txtCountdown;
export let dividerColor;
export let dividerHeight;
export let topContainerHeight;
const formatDateTime = (dateString) => {
    var _a, _b;
    const dt = DateTime.fromISO(dateString, { zone: "Europe/London" });
    const convertedDateTime = (_a = dt
        .toLocaleString({
        weekday: "short",
        year: "numeric",
        month: "short",
        day: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
        timeZoneName: "short",
    })) === null || _a === void 0 ? void 0 : _a.split(" ");
    return (_b = convertedDateTime === null || convertedDateTime === void 0 ? void 0 : convertedDateTime.filter((string) => string !== "at")) === null || _b === void 0 ? void 0 : _b.map((string) => string.trim().replace(",", ""));
};
$: dateTimeArray = formatDateTime(matchDateTime);
$: month = dateTimeArray ? dateTimeArray[1] : undefined;
$: day = dateTimeArray
    ? `${dateTimeArray[0]} ${dateTimeArray[2]}`
    : undefined;
$: targetDate = new Date(matchDateTime).getTime();
let countdownText = "";
let countdownInterval;
function updateTimer() {
    const now = new Date().getTime();
    const distance = targetDate - now;
    // If the countdown is finished, display all zeros
    if (distance < 0) {
        countdownText = "0:00:00:00";
        return;
    }
    // Time calculations for days, hours, minutes, and seconds
    const days = Math.floor(distance / (1000 * 60 * 60 * 24));
    const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
    const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
    const seconds = Math.floor((distance % (1000 * 60)) / 1000);
    // Pad hours, minutes, and seconds with leading zeros if they are less than 10
    const paddedHours = hours.toString().padStart(2, "0");
    const paddedMinutes = minutes.toString().padStart(2, "0");
    const paddedSeconds = seconds.toString().padStart(2, "0");
    // Format: Days:Hours:Minutes:Seconds
    countdownText = `${days}:${paddedHours}:${paddedMinutes}:${paddedSeconds}`;
}
$: {
    if (countdownInterval) {
        clearInterval(countdownInterval);
        countdownInterval = undefined;
    }
    if (matchStatus === "pre" && targetDate) {
        updateTimer();
        countdownInterval = setInterval(updateTimer, 1000);
    }
}
onDestroy(() => { if (countdownInterval)
    clearInterval(countdownInterval); });
</script>

<BaseAtom _isotope="MinimalFixturesAtom" {...container}>
  <div
    class="fixtures-container"
    style="--divider-color: {dividerColor}; --divider-height: {dividerHeight}; --top-height: {topContainerHeight};"
  >
    {#if showCompLogo}
      <ButtonParticle {...btnCupName} />
    {/if}
    <div class="main-content">
      <div class="status-wrapper">
        <div
          class="date-time"
          style="visibility: {matchStatus === 'pre' ? 'visible' : 'hidden'}"
        >
          <TextParticle {...txtMatchMonth} text={month} />
          <TextParticle {...txtMatchDay} text={day} />
        </div>
        <div
          class="live-container"
          style="visibility: {matchStatus === 'live' ? 'visible' : 'hidden'}"
        >
          <TextParticle {...txtLive} />
          <TextParticle {...txtLiveScore} text={txtResult?.text} />
        </div>
        <div
          class="match-result"
          style="visibility: {matchStatus === 'post' ? 'visible' : 'hidden'}"
        >
          <TextParticle {...txtResult} />
        </div>
      </div>
      <div class="team-image">
        <ImageParticle {...imageAwayTeam} />
      </div>
      <div class="bottom-section">
        <div class="team-name">
          <TextParticle {...txtVersus} />
          <TextParticle {...txtAwayTeam} />
        </div>
        <div class="bottom-buttons">
          {#each btnActions || [] as button}
            <ButtonParticle {...button} />
          {/each}
        </div>
      </div>
    </div>
    <div class="expand-wrapper">
      <div class="expand-content">
        <div class="divider"></div>s
        <div class="bottom-content" class:pre-game={matchStatus === "pre"}>
          {#if matchStatus === "pre"}
            <TextParticle {...txtCountdown} text={countdownText} />
          {/if}
          {#each btnSponsors || [] as button}
            <ButtonParticle {...button} />
          {/each}
        </div>
      </div>
    </div>
  </div>
</BaseAtom>

<style>
  .fixtures-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    align-self: stretch;
  }

  .main-content {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: var(--top-height, 100%);
    flex-grow: 1;
  }

  .status-wrapper {
    display: grid;
    grid-template-areas: "stack";
    align-items: center;
    justify-items: center;
    width: 100%;
  }

  .date-time,
  .live-container,
  .match-result {
    grid-area: stack;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
    text-align: center;
  }

  .live-container {
    gap: 5px;
  }

  .bottom-section {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    flex-grow: 1;
  }

  .team-name {
    width: 100%;
    text-align: center;
    margin-bottom: 10px;
  }

  .bottom-buttons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: 100%;
  }

  .expand-wrapper {
    display: grid;
    grid-template-rows: 0fr;
    width: 100%;
    transition: grid-template-rows 0.35s ease-out;
  }

  .fixtures-container:hover .expand-wrapper {
    grid-template-rows: 1fr;
  }

  .expand-content {
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    width: 100%;
  }

  .divider {
    width: 85%;
    height: var(--divider-height, 2px);
    background-color: var(
      --divider-color,
      var(--theme-primary-background-color)
    );
    border: none;
    margin: 20px 0px 0px 0px;
  }

  .bottom-content {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .bottom-content.pre-game {
    width: 85%;
    justify-content: space-between;
  }</style>
